import src from "IMAGE";
export default { src, width: 316, height: 189, blurWidth: 0, blurHeight: 0};
